import { ApiAction, KeyValuePair } from "./types";

export const fetchData = async <T>(
    url: string,
    sendRequest: <T>(action: ApiAction<T>) => Promise<void>,
    onComplete: (data: T[]) => void,
    queryParameters?: KeyValuePair<string>[]
) => {
    const action: ApiAction<T[]> = {
        method: 'GET',
        onComplete: (resp: T[]) => {
            onComplete(resp);
        },
        url,
    };

    if (!!queryParameters) {
        action.queryParameters = queryParameters;
    }

    await sendRequest(action);
};

export const fetchDataAsync = async <T>(
    url: string,
    sendRequest: <T>(action: ApiAction<T>) => Promise<void>,
    onComplete: (data: T) => void,
    headers: HeadersInit,
    getBearerToken?: () => Promise<string> ,
    queryParameters?: KeyValuePair<string>[]
) => {
    
    if (!!getBearerToken) {
        const token = await getBearerToken();
        headers = {...headers, Authorization: `Bearer ${token}`}
    }

    const action: ApiAction<T> = {
        method: 'GET',
        nonNcassEndpoint: !getBearerToken,
        onComplete,
        url,
        headers
    };

    if (!!queryParameters) {
        action.queryParameters = queryParameters;
    }
    await sendRequest(action);
};

export const buildQueryParameters = (queryParameters: KeyValuePair<string>[]) => {
    let paramStr = '?';

    queryParameters.forEach((qp, i) => {
        const key = Object.keys(qp)[0];
        paramStr += `${key}=${qp[key]}`;
        if (i < queryParameters.length - 1) paramStr += '&';
    });

    return paramStr;
};

